"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports["default"] = exports.PortalNameCell = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var mapStateToProps = function mapStateToProps(state) {
  var portals = state.portals,
      activePortal = state.activePortal;
  var linkedPortals = state.informationLists.linkedPortals;
  return {
    linkedPortals: linkedPortals,
    portals: portals,
    activePortal: activePortal
  };
};

exports.mapStateToProps = mapStateToProps;

var PortalNameCell = function PortalNameCell(_ref) {
  var portalId = _ref.portalId,
      linkedPortals = _ref.linkedPortals,
      portals = _ref.portals,
      activePortal = _ref.activePortal;
  var portal; // check if its is my own portal

  if (parseInt(portalId, 10) === parseInt(activePortal, 10)) {
    portal = portals[portalId];
  } else {
    // if not, it must be from a linked portal
    portal = linkedPortals[portalId];
  }

  if (portal) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "portal-name"
    }, portal.name);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "no-portal-found"
  });
};

exports.PortalNameCell = PortalNameCell;
PortalNameCell.propTypes = {
  portalId: _propTypes["default"].number,
  activePortal: _propTypes["default"].number.isRequired,
  linkedPortals: _propTypes["default"].instanceOf(Object).isRequired,
  portals: _propTypes["default"].instanceOf(Object).isRequired
};
PortalNameCell.defaultProps = {
  portalId: null
};
var ConnectedPortalNameCell = (0, _reactRedux.connect)(mapStateToProps)(PortalNameCell);

var renderer = function renderer(_ref2) {
  var cellData = _ref2.cellData;
  return /*#__PURE__*/_react["default"].createElement(ConnectedPortalNameCell, {
    portalId: cellData
  });
};

renderer.propTypes = {
  cellData: _propTypes["default"].string
};
renderer.defaultProps = {
  cellData: ''
};
var _default = renderer;
exports["default"] = _default;